// index-brandone.ts

// Favicons
import '@/ui/favicon/android-chrome-192x192.png';
import '@/ui/favicon/android-chrome-512x512.png';
import '@/ui/favicon/apple-touch-icon.png';
import '@/ui/favicon/favicon-16x16.png';
import '@/ui/favicon/favicon-32x32.png';
import '@/ui/favicon/favicon.ico';
import '@/ui/favicon/mstile-150x150.png';
import '@/ui/favicon/mstile-150x150.png';
import '@/ui/favicon/safari-pinned-tab.svg';
import '@/ui/favicon/browserconfig.xml';
import '@/ui/favicon/site.webmanifest';

// Styles
import '@/ui/styles/main-brandone';

// Icon Sprite
// SSEN Logos
import '@/ui/icons/SSENT/SSENT-logo.svg';
import '@/ui/icons/SSENT/default-icon.svg';
import '@/ui/icons/SSENT/power-cut.svg';

// Component-specific icons
// Shared - Socials - footer & social share components
import '@/ui/icons/components/_shared/social/facebook-circled.svg';
import '@/ui/icons/components/_shared/social/instagram-circled.svg';
import '@/ui/icons/components/_shared/social/linkedin-circled.svg';
import '@/ui/icons/components/_shared/social/mail-circled.svg';
import '@/ui/icons/components/_shared/social/tiktok-circled.svg';
import '@/ui/icons/components/_shared/social/x-circled.svg';
import '@/ui/icons/components/_shared/social/vimeo-circled.svg';
import '@/ui/icons/components/_shared/social/whatsapp-circled.svg';
import '@/ui/icons/components/_shared/social/youtube-circled.svg';
// Shared - File types - Document download + library components
import '@/ui/icons/components/_shared/file-types/file-doc.svg';
import '@/ui/icons/components/_shared/file-types/file-file.svg';
import '@/ui/icons/components/_shared/file-types/file-jpeg.svg';
import '@/ui/icons/components/_shared/file-types/file-pdf.svg';
import '@/ui/icons/components/_shared/file-types/file-png.svg';
import '@/ui/icons/components/_shared/file-types/file-ppt.svg';
import '@/ui/icons/components/_shared/file-types/file-xlx.svg';
import '@/ui/icons/components/_shared/file-types/file-xlsx.svg';
import '@/ui/icons/components/_shared/file-types/file-mov.svg';
import '@/ui/icons/components/_shared/file-types/file-wav.svg';
import '@/ui/icons/components/_shared/file-types/file-mp3.svg';
import '@/ui/icons/components/_shared/file-types/file-mp4.svg';
import '@/ui/icons/components/_shared/file-types/file-avi.svg';
// General icons
import '@/ui/icons/arrow-left.svg';
import '@/ui/icons/arrow-right.svg';
import '@/ui/icons/burger-menu.svg';
import '@/ui/icons/circle-solid.svg';
import '@/ui/icons/close.svg';
import '@/ui/icons/cross-circled.svg';
import '@/ui/icons/down-arrow.svg';
import '@/ui/icons/download.svg';
import '@/ui/icons/email.svg';
import '@/ui/icons/help.svg';
import '@/ui/icons/info.svg';
import '@/ui/icons/info-filled.svg';
import '@/ui/icons/warning-filled.svg';
import '@/ui/icons/minus.svg';
import '@/ui/icons/next.svg';
import '@/ui/icons/personal.svg';
import '@/ui/icons/phone.svg';
import '@/ui/icons/play.svg';
import '@/ui/icons/plus.svg';
import '@/ui/icons/prev.svg';
import '@/ui/icons/quotemark.svg';
import '@/ui/icons/search.svg';
import '@/ui/icons/three-dots-circled.svg';
import '@/ui/icons/tick-circled.svg';
import '@/ui/icons/tick.svg';
import '@/ui/icons/triangle.svg';
import '@/ui/icons/visibility--off.svg';
import '@/ui/icons/visibility.svg';
import '@/ui/icons/plyr-play.svg';
import '@/ui/icons/plyr-pause.svg';

// Map icons
import '@/ui/icons/components/map/completed.svg';
import '@/ui/icons/components/map/existing-infrastructure.svg';
import '@/ui/icons/components/map/existing-substation.svg';
import '@/ui/icons/components/map/in-construction.svg';
import '@/ui/icons/components/map/location.svg';
import '@/ui/icons/components/map/opportunity-assessment.svg';
import '@/ui/icons/components/map/potential-development.svg';
import '@/ui/icons/components/map/rating-132.svg';
import '@/ui/icons/components/map/rating-275.svg';
import '@/ui/icons/components/map/rating-400.svg';
import '@/ui/icons/components/map/refinement.svg';
import '@/ui/icons/components/map/selected-infrastructure.svg';
import '@/ui/icons/components/map/substation.svg';
import '@/ui/icons/components/map/user-guide.svg';

// Images
import '@/ui/images/jpg/card-default.jpg';
import '@/ui/images/jpg/mini-map-example.jpg';
import '@/ui/images/png/lazy-load-placeholder.png';
import '@/ui/images/png/location.png';
import '@/ui/images/png/power.png';
import '@/ui/images/png/SSEN-logo.png';
import '@/ui/images/png/substation.png';
import '@/ui/images/png/substation-selected.png';

// Project Statusbar
import '@/ui/images/svg/project-status/desktop-stage-1.svg';
import '@/ui/images/svg/project-status/desktop-stage-2.svg';
import '@/ui/images/svg/project-status/desktop-stage-3.svg';
import '@/ui/images/svg/project-status/desktop-stage-4.svg';
import '@/ui/images/svg/project-status/desktop-stage-5.svg';
import '@/ui/images/svg/project-status/mobile-stage-1.svg';
import '@/ui/images/svg/project-status/mobile-stage-2.svg';
import '@/ui/images/svg/project-status/mobile-stage-3.svg';
import '@/ui/images/svg/project-status/mobile-stage-4.svg';
import '@/ui/images/svg/project-status/mobile-stage-5.svg';

// Scripts
import 'core-js/modules/es.promise';
import 'core-js/modules/es.array.iterator';
import 'regenerator-runtime/runtime';

import bodyOverlayObserver from '@/ui/scripts/lib/body-overlay-observer';
import polyfill from '@/ui/scripts/lib/polyfill';
import accessibility from '@/ui/scripts/lib/accessibility';
import analytics from '@/ui/scripts/analytics/analytics';

import moduleLoader from '@/ui/scripts/module-loader';

// Mock Services
async function makeServer() {
  const { default: server }: { default: () => void } = await import('@/api/server');
  server();
}
if (process.env.NODE_ENV === 'development') {
  makeServer();
}

document.addEventListener(
  'DOMContentLoaded',
  () => {
    document.getElementsByTagName('html')[0].classList.remove('no-js');

    // Lib
    bodyOverlayObserver();
    polyfill.polyfillClosest();
    polyfill.polyfillRemove();
    accessibility();
    analytics();

    // ES6 modules loaded dynamically based on DOM query
    const modules: HTMLElement[] = Array.from(document.querySelectorAll('.js-module'));
    moduleLoader(modules);
  },
  false,
);
